import { Icon16Image, Icon16SoundOn, Icon16Text, Icon16Video, Icon24Transform3dLarge } from '@figma/fpl-icons';
import { I18N_KEYS } from '@/language/keys';
import type { TFunction } from 'i18next';
import type { DesignAppResult } from '@/types/design-app.types';

const labels = I18N_KEYS.SHARED_DESIGN_APP.OUTPUT_HISTORY;

export const outputTypeLabels = {
  image: { Icon: Icon16Image, label: labels.IMAGE },
  video: { Icon: Icon16Video, label: labels.VIDEO },
  audio: { Icon: Icon16SoundOn, label: labels.AUDIO },
  '3D': { Icon: Icon24Transform3dLarge, label: labels.THREE_D },
  text: { Icon: Icon16Text, label: labels.TEXT },
} satisfies Record<DesignAppResult['type'], { Icon: typeof Icon16Image; label: string }>;

export function getToolOutputName(result: Pick<DesignAppResult, 'name' | 'type'>, t: TFunction): string {
  return result.name || t(outputTypeLabels[result.type]?.label || I18N_KEYS.GENERAL.OUTPUT);
}
